import { METERS_IN_MI, METERS_IN_KM, UNIT_MI } from '@/util/constants';

const DEFAULT_MIN_RADIUS = 10; // km, when location type doesn't have min radius
const DEFAULT_EXTENSION_MULTIPLIER = 1.4;

// Offset bounds based on panel and map widths
// this prevents panel from overlapping bounds
// extensionMultiplier increases the spacing between panel edge and locations
const offsetBounds = (
  extend,
  limits,
  bounds,
  panelWidth,
  mapWidth,
  extensionMultiplier = DEFAULT_EXTENSION_MULTIPLIER,
) => {
  const boundsLimits = limits(bounds);
  const boundsWidth = Math.abs(boundsLimits.west - boundsLimits.east);
  const extensionOffset = ((boundsWidth * panelWidth) / mapWidth) * extensionMultiplier;
  const extensionPoint = {
    lat: boundsLimits.south,
    lng: boundsLimits.west - extensionOffset,
  };

  return extend(bounds, extensionPoint);
};

/*
  get bounds for circle (lat, lng, radius in meters)
  extend bounds by bounds
  extend bounds by point
*/

// eslint-disable-next-line
export default (circle, extend, limits, locations, minBounds, panelWidth, screenWidth, initial, unit) => {
  const DISTANCE = unit === UNIT_MI ? METERS_IN_MI : METERS_IN_KM;
  if (!locations.length) {
    return circle(initial.center.lat, initial.center.lng, initial.radius * DISTANCE);
  }

  let bounds = null; // new maps.LatLngBounds();

  locations.forEach(loc => {
    const minRadius = minBounds[loc.type] ? minBounds[loc.type] : DEFAULT_MIN_RADIUS;

    const boundsCircle = circle(loc.lat, loc.lng, Math.max(minRadius, loc.radius) * DISTANCE);

    if (bounds) {
      bounds = extend(bounds, boundsCircle);
    } else {
      bounds = boundsCircle;
    }
  });

  const mapWidth = screenWidth - panelWidth;
  if (mapWidth) {
    bounds = offsetBounds(extend, limits, bounds, panelWidth, mapWidth);
  }

  return bounds;
};



// WEBPACK FOOTER //
// ./src/util/location-bounds.js